var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, ElementRef } from '@angular/core';
import { Office } from '../../../classes/office';
import { SCREEN_SIZE, ContactFormLocationType } from '../../../classes/enums';
import { PageProfileComponent } from '../page-profile.component';
import { DetailStub } from '../../listing-details/detail-section/detail-section.component';
import { Agent } from '../../../classes/agent';
import { Pagination } from '../../../classes/pagination';
import { HistoryItem } from '../../../classes/history-item';
import { MapOfficeToLead } from '../../../classes/leads';
import { skip } from 'rxjs/operators';
import { IBlogResponse, IBlogItem } from '../../../classes/interfaces';
import { get } from 'lodash-es';
var OfficeProfileComponent = /** @class */ (function (_super) {
    __extends(OfficeProfileComponent, _super);
    function OfficeProfileComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.office = new Office();
        _this.officeAgents = [];
        _this.officeListings = [];
        _this.specialitiesNumColumns = [];
        _this.maxNumberItemsPerList = 15;
        _this.fastFactRowsDesktopOnly = [];
        _this.ContactFormLocationType = ContactFormLocationType;
        // Enum
        _this.Agent = Agent;
        _this._agentPaginationLimitPerPage = 3;
        _this._officePaginationLimitPerPage = 10;
        return _this;
    }
    OfficeProfileComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.addSub(this.activatedRoute.data.subscribe(function (_a) {
            var user = _a.user, office = _a.office, screenSize = _a.screenSize;
            _this.leadInfo = MapOfficeToLead(office);
            _this.setUserDetailsForContactForm(user);
            _this._setAgentPaginationForScreenSize(screenSize);
            _this._getAllOfficeInfo(office);
        }));
        // First skipped due to resolver
        this.addSub(this.userService.currentUser.pipe(skip(1)).subscribe(function (user) { return _this.setUserDetailsForContactForm(user); }));
        this.blogService.getByTags(['cms-office-details-side']).toPromise()
            .then(function (results) {
            _this.ad = get(results, '[0].content');
        });
    };
    OfficeProfileComponent.prototype.getListSize = function (index) {
        return Math.min((index + 1) * this.maxNumberItemsPerList, this.office.specialties.length);
    };
    OfficeProfileComponent.prototype.onListingChanged = function (event) {
        if (this.listingsPagination.pageNumber > this.listingsPagination.totalPages)
            return;
        // We paginate just before they reach the end of the current listings
        if (event.index >= this.listingsPagination.offset - this.minListingsLeftBeforeRetrievingNew) {
            this.listingsPagination.pageNumber++;
            this.getOfficeListings();
        }
    };
    OfficeProfileComponent.prototype.getOfficeListings = function (pagination) {
        var _this = this;
        if (pagination)
            this.listingsPagination = pagination;
        // this.hasRetrievedSuggestedListings = false;
        this.officeService.getListingsPreviewsForOffice(this.office.personifyId, this.listingsPagination).then(function (response) {
            _this.hasRetrievedSuggestedListings = true;
            _this.listingsPagination.setTotalResults(response.totalHits);
            _this.officeListings = _this.officeListings.concat(response.results);
            _this.productSchema = _this.listingsService.checkForProductValues(_this.officeListings);
        });
    };
    OfficeProfileComponent.prototype.getAgents = function (pagination) {
        var _this = this;
        this.agentPagination = pagination;
        this.officeService.getAgentsForOffice(this.office.personifyId, this.agentPagination).then(function (response) {
            _this.agentPagination.setTotalResults(response.totalHits);
            _this.officeAgents = response.results;
            // TODO: this.hasRetrievedAgents
            _this.domManipulationService.scrollIntoView(_this.alElementRef, true);
        });
    };
    OfficeProfileComponent.prototype._setAgentPaginationForScreenSize = function (screenSize) {
        this._agentPaginationLimitPerPage = screenSize === SCREEN_SIZE.MOBILE_ONLY ? 3 : 8;
        this.screenSize = screenSize;
    };
    OfficeProfileComponent.prototype._getAllOfficeInfo = function (office) {
        if (!office)
            return;
        this.office = office;
        this.isLoading = false;
        this.metaTagService.setPageTitle('meta-tags.office-profile.title', { city: this.office.city, name: this.office.officeName, province: this.office.state });
        this.metaTagService.setPageDescription('meta-tags.office-profile.description', { name: this.office.officeName });
        this.metaTagService.setOpenGraphTags([
            {
                name: 'title',
                content: 'meta-tags.office-profile.title',
                variables: { city: this.office.city, name: this.office.officeName, province: this.office.state },
                isTranslateKey: true
            },
            {
                name: 'description',
                content: 'meta-tags.office-profile.description',
                variables: { name: this.office.officeName },
                isTranslateKey: true
            },
        ]);
        this.prerenderService.setPreRenderFlag(200);
        // this.office.personifyId = officeId;
        if (this.office.latitude && this.office.longitude) {
            this.latLng = {
                lat: this.office.latitude,
                lng: this.office.longitude
            };
        }
        this.fastFactRows = [
            new DetailStub({ title: 'page-profile.languages', value: this.office.languages.join(', ') }),
            new DetailStub({ title: 'page-profile.types', value: this.office.propertyTypes.join(', ') }),
        ];
        this.fastFactRowsDesktopOnly = [
            new DetailStub({ title: 'page-profile.languages', value: this.office.languages.join(', ') }),
            new DetailStub({ title: 'page-profile.types', value: this.office.propertyTypes.join(', ') }),
            new DetailStub({ title: 'page-profile.contact', value: this.office.parsedPhoneNumber })
        ];
        // We hack something here to create a useless array initialized with 1
        // TODO SSR: Save Listings, Agents in Transfer State, do not set prerender flag until everything returned.
        if (this.office.specialties)
            this.specialitiesNumColumns = new Array(Math.round(this.office.specialties.length / this.maxNumberItemsPerList)).map(function (r) { return 1; });
        this.getOfficeListings(this.listingsPagination);
        this.getAgents(new Pagination(0, this._agentPaginationLimitPerPage));
        this.historyService.push(new HistoryItem({ officeId: '' + this.office.personifyId, detailUrl: this.office.detailUrl }));
        this.getCmsLinks(office.state, office.city);
        // this.getInternalLinks('opp', office.state, office.city);
    };
    return OfficeProfileComponent;
}(PageProfileComponent));
export { OfficeProfileComponent };
